/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { HashRouter, Route } from 'trux'

import TeamsContainer from './containers/TeamsContainer'

import StaffContainer from './containers/StaffContainer'
import TeamEditContainer from './containers/TeamEditContainer'
import AddTeamContainer from './containers/AddTeamContainer'
import MemberEditContainer from './containers/MemberEditContainer'
import FieldAppContainer from './containers/FieldAppContainer'
import OwnerSetupContainer from './containers/OwnerSetupContainer'
import MemberSetupContainer from './containers/MemberSetupContainer'
import TeamMemberSetupContainer from './containers/TeamMemberSetupContainer'
import HomePage from './containers/HomePage'
import {statAdminPageView } from '../../util/analytics'
import { RequireUser } from '../../modules/Session'

import './Admin.css'

const appPageChanged = () => {
    statAdminPageView(window.location.hash)
    window.scrollTo(0, 0)
    return null
}

export default class Admin extends Component {
    render() {
        // <Route path="/:team/settings" component={AdminLoader} />
        return (
            <HashRouter>
                <div className="Admin">
                    <Route path="/:team/settings/division/:division_id" component={AdminLoader} />
                    <Route path="/:team/settings" component={RequireUser} />
                    <Route path="/:team/settings" component={appPageChanged} />
                    <Route exact path="/:team/settings" component={HomePage} />
                    <Route exact path="/:team/settings/division/:division_id" component={HomePage} />
                    <Route exact path="/:team/settings/division/:division_id/magic/:user/:token" component={HomePage} />
                    <Route exact path="/:team/settings/division/:division_id/teams" component={TeamsContainer} />
                    <Route exact path="/:team/settings/division/:division_id/teams/:team_id/edit" component={TeamEditContainer} />
                    <Route exact path="/:team/settings/division/:division_id/teams/:team_id/edit/magic/:user/:token" component={TeamEditContainer} />
                    <Route exact path="/:team/settings/division/:division_id/teams/add" component={AddTeamContainer} />
                    <Route exact path="/:team/settings/division/:division_id/staff" component={StaffContainer} />
                    <Route exact path="/:team/settings/division/:division_id/staff/magic/:user/:token" component={StaffContainer} />
                    <Route exact path="/:team/settings/division/:division_id/staff/:user_id/edit" component={MemberEditContainer} />
                    <Route exact path="/:team/settings/division/:division_id/staff/:user_id/edit/magic/:user/:token" component={MemberEditContainer} />
                </div>
            </HashRouter>
        )
    }
}

export class AdminInvites extends Component {
    render() {
        return (
            <HashRouter>
                <div className="Admin">
                    <Route exact path="/invite/:invite_id/:invite_code/division/:division_id/fieldapp/:alone" component={FieldAppContainer} />
                    <Route exact path="/invite/:invite_id/:invite_code/division/:division_id/setup/owner/:user_id" component={OwnerSetupContainer} />
                    <Route exact path="/invite/:invite_id/:invite_code/division/:division_id/setup/member/:user_id" component={MemberSetupContainer} />
                    <Route exact path="/invite/:invite_id/:invite_code/team/:team_id/setup/member/:user_id" component={TeamMemberSetupContainer} />
                </div>
            </HashRouter>
        )
    }
}

class AdminLoaderComponent extends Component {

    componentDidUpdate(prevProps) {
        let nextProps = this.props

        if (nextProps.match.params.team && nextProps.divisions && nextProps.divisions.length > 0) {
            let division = null
            let team = null

            let divisionId = parseInt(nextProps.match.params.division_id, 10)
            for (let div of nextProps.divisions) {
                if (div.division_id === divisionId) {
                    division = div
                }
            }

            if (division) {
                for (let tm of division.myTeams) {
                    if (tm.name === this.props.teamId) {
                        team = tm
                        break
                    }
                }
            }

            if (!division || !team) {
                let nextUrl = null
                for (let div of nextProps.divisions) {
                    if (div.teams.length > 0) {
                        let nextTeam = div.teams[0].name
                        let nextDiv = div.division_id
                        nextUrl = window.location.href.replace(nextProps.match.params.team, nextTeam)
                        nextUrl = nextUrl.replace(nextProps.match.params.division_id, nextDiv)
                    }
                }
                if (nextUrl) {
                    console.log('Admin redirect to', nextUrl)
                    window.location.href = nextUrl
                } else {
                    console.error('Admin redirect failed not possible division/team to route to')
                }
            }
        }
    }

    render() {
        return null
    }
}

const mapStateToProps = (state, cProps) => {
    const divisions = state.divisions.value ? state.divisions.value : []
    const currentTeam = state.team.value ? state.team.value : null
    const teamId = cProps.match.params.team
    const user = state.user.value ? state.user.value : null
    const rev = new Date()

    return {
        divisions,
        currentTeam,
        teamId,
        user,
        rev
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        init: (teamId) => {
            //dispatch(navAct.init(teamId))
        },
        loadDivisions: () => {
            //dispatch(act.loadDivisions())
        }
    }
}

export const AdminLoader = connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminLoaderComponent)


